import React, { useEffect, useRef, useState } from 'react';
import '../../assets/styles/scss/pages/_login.scss';
import ButtonUC from '../../components/buttonUC';
import { Col, Form, message, Modal, Row, Spin, Tooltip, Typography } from 'antd';
import { ReactComponent as ImageUserEmpty } from '../../assets/images/login/Profile.svg';
import config from '../../config';
import { EllipsisOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { ModalRc } from '../../components/modalRc';
import InputUC from '../../components/Form/InputUC';
import SelectUC from '../../components/Form/SelectUC';
import TextAreaUC from '../../components/Form/TextAreaUC';
import axiosRc from '../../config/axios-rc';

const FormSignOut = (props) => {
    const { userData, handleLogOut, showButton = true, onOkLogOut, setOpenModalLogin } = props;
    const { Text } = Typography;
    const [showDelete, setShowDelete] = useState(false);
    const [delAccReasonDeleteData, setDelAccReasonDeleteData] = useState([]);
    const [dataDelAccResson, setDataDelAccResson] = useState(null);
    const [isShowModalDeleteAcc, setIsShowModalDeleteAcc] = useState(false);
    const [formDelete] = Form.useForm();
    const dataDelAccRemark = Form.useWatch('delAccReason', formDelete);
    const isMobile = window.innerWidth <= 768
    const isActionDelAcc = useRef(false);

    useEffect(() => {
        if (userData && userData.isLoggedIn === true) {
            fetchDropdownByType();
        }
    }, []);

    useEffect(() => {
        formDelete.setFields([
            {
                name: 'delAccRemark',
                errors: null,
            },
        ]);
    }, [dataDelAccRemark]);

    const deleteAcc = () => {
        setShowDelete(!showDelete);
    };

    const selectValueDeleteAcc = (val) => {
        formDelete.setFieldsValue({ delAccRemark: null });
        let data = delAccReasonDeleteData.find((item) => item.value === val);
        if (data) {
            setDataDelAccResson(data.code);
        }
    };

    const fetchDropdownByType = async () => {
        const param = '?dropdownType=delAccReason';
        const res = await axiosRc.get('dropdown/get_dropdown_by_type' + param);
        const delAccReason = [];
        if (res && res.data) {
            res.data.map((item) => {
                delAccReason.push({
                    value: item.dropdownNameTh,
                    label: item.dropdownNameTh,
                    isDeleted: item.isDeleted ?? false,
                    isInactive: item.isInactive ?? false,
                    sort: item.sort,
                    code: item.dropdownCode,
                });
            });
        }

        delAccReason.sort(function (a, b) {
            return a.sort > b.sort ? 1 : -1;
        });
        setDelAccReasonDeleteData(delAccReason);
    };

    const FormReasonDeleteAcc = () => {
        return (
            <div className='p-4'>
                <Form
                    className='div-body-delete'
                    form={formDelete}
                    layout='vertical'
                    autoComplete='off'
                >
                    <div className='flex justify-center items-center'>
                        <ExclamationCircleFilled className='modal-confirm-delete' />
                    </div>
                    <Row className='py-2 mb-6 text-lg font-bold flex justify-center text-center'>
                        <div className='delete-acc-bold'>คำเตือน!! การดำเนินการนี้จะลบบัญชีของคุณถาวร</div>
                        <div className='delete-acc-bold'>ข้อมูลทั้งหมดของคุณจะถูกลบออก และคุณจะถูกเพิกถอนจากงานใด ๆ ที่คุณสมัครไว้</div>
                    </Row>
                    <Row xs={24} md={24} className='py-2'>
                        <Col xs={24} md={24} className='px-2'>
                            <InputUC
                                label='อีเมล'
                                placeholder={'กรุณากรอกอีเมล'}
                                maxLength={100}
                                required={true}
                                name={'email'}
                            />
                        </Col>
                        <Col xs={24} md={24} className='px-2'>
                            <SelectUC
                                className='modal-message-delete.ant-modal-content.ant-modal-body.anticon'
                                label='เหตุผลการลบบัญชี'
                                required={true}
                                name={'delAccReason'}
                                optionValues={delAccReasonDeleteData}
                                onChange={selectValueDeleteAcc}
                            />
                        </Col>
                        <Col xs={24} md={24} className='px-2'>
                            {/* <InputUC
                                required={dataDelAccResson === 'other'}
                                label='ระบุเหตุผลอื่น ๆ ที่ต้องการลบบัญชี  '
                                placeholder='กรุณากรอกอื่นๆ'
                                name={'delAccRemark'}
                                maxLength={1000}
                                disabled={dataDelAccResson !== 'other'}
                                showPlaceholder={dataDelAccResson === 'other'}
                            /> */}

                            <TextAreaUC
                                required={dataDelAccResson === 'other'}
                                label="ระบุเหตุผลอื่น ๆ ที่ต้องการลบบัญชี :"
                                placeholder="กรุณากรอกอื่นๆ"
                                name={"delAccRemark"}
                                maxLength={1000}
                                disabled={dataDelAccResson !== 'other'}
                            />
                        </Col>
                        <Col className='px-2'>
                            <div className='text-red-500' style={{ whiteSpace: 'nowrap' }}>
                                ** เมื่อลบบัญชีแล้วจะ
                                <span style={{ fontWeight: 'bold' }}>ไม่สามารถยกเลิกในภายหลังได้</span>
                            </div>
                        </Col>
                        <Col className='px-2'>
                            <div className='text-red-500'>
                                โดยข้อมูลส่วนตัวและประวัติการสมัครงานทุกตำแหน่งของคุณ ที่ได้สมัครไว้กับทางสภากาชาดไทยจะถูกเพิกถอนและถูกลบออกไปอย่างถาวร **
                            </div>
                        </Col>
                    </Row>
                    <Row className='justify-center grid grid-cols-2 gap-2 pt-4 pb-10'>
                        <ButtonUC className='btn-clear w-full'
                            onClick={() => setIsShowModalDeleteAcc(false)}
                        >ยกเลิก</ButtonUC>
                        <ButtonUC
                            className='btn-custom w-full'
                            onClick={confirmPopDeleteAcc}
                        >
                            ลบบัญชี
                        </ButtonUC>
                    </Row>
                </Form>
            </div>
        );
    };

    const confirmPopDeleteAcc = async () => {

        if (!validate() && !isActionDelAcc.current) {
            isActionDelAcc.current = true;
            setTimeout(() => {
                isActionDelAcc.current = false;
            }, 5000)
            const delAccReasonCode = delAccReasonDeleteData?.find(d => d.value === formDelete.getFieldValue('delAccReason'))?.code;
            const body = {
                email: formDelete.getFieldValue('email'),
                delAccReason: delAccReasonCode ?? null,
                delAccRemark: formDelete.getFieldValue('delAccRemark'),
                createdByName: userData.name,
            };

            const { data } = await axiosRc.post(`deleteHistory/create_delete_history`, body);
            let propsModal = {};
            setOpenModalLogin(false)
            setIsShowModalDeleteAcc(false)
            isActionDelAcc.current = false;
            if (data.isGroup2) {
                // setIsShowModalDeleteAcc(false)
                // setOpenModalLogin(false)
                propsModal = {
                    type: 'warning',
                    classModal: `error ${isMobile && '!flex !justify-center !inset-x-0'}`,
                    title: <>{warningDeleteAcc()}</>,
                    okText: 'ปิด',
                    onOk: () => {
                        onOkLogOut()
                        // setIsShowModalDeleteAcc(false)
                    },
                    width: isMobile ? '90%' : '440px',
                    style: isMobile ? {
                        top: '50%',
                        transform: 'translateY(-50%)',
                    } : {}
                };
            } else {
                propsModal = {
                    type: 'success',
                    classModal: `approves  ${isMobile && '!flex !justify-center !inset-x-0'}`,
                    title: <>{ApprovesDeleteAcc()}</>,
                    content: <>{formApprovesDeleteAcc()}</>,
                    okText: 'ปิด',
                    onOk: () => {
                        onOkLogOut()
                        // setIsShowModalDeleteAcc(false)
                    },
                    width: isMobile ? '90%' : '440px',
                    style: isMobile ? {
                        top: '50%',
                        transform: 'translateY(-50%)',
                    } : {}
                };
            }
            ModalRc(propsModal);
            return false;
        } else {
            return true;
        }
    };

    const validate = () => {
        let isValidate = false;
        let isValidateState = false;

        const dataPreSubmit = {
            email: formDelete.getFieldValue('email'),
        };

        const dataColValidate = [
            { caption: 'กรุณากรอกอีเมล', columnName: 'email' },
            { caption: 'กรุณาเลือกเหตุผลการลบบัญชี', columnName: 'delAccReason' },
            { caption: 'กรุณากรอกอื่นๆ', columnName: 'delAccRemark' },
        ];

        dataColValidate.forEach((el) => {
            const _isValidate = checvalidateDraft(el);
            isValidate = isValidate ? isValidate : _isValidate ?? false;
            isValidateState = isValidate;
        });

        if (isValidate) {
            message.warning('กรุณาตรวจสอบข้อมูล');
        } else if (dataPreSubmit.email !== userData.email) {
            isValidateState = true;
            formDelete.setFields([{ name: ['email'], errors: ['อีเมลไม่ตรงกับข้อมูลที่เคยสมัครไว้ ตรวจสอบและกรอกอีเมลให้ถูกต้อง'] }]);
        }

        if (dataDelAccResson !== 'other') {
            formDelete.setFields([{ name: ["delAccRemark"], errors: [] }]);
        }

        return isValidateState;
    };

    const checvalidateDraft = (e) => {
        const _data = formDelete.getFieldValue([e.columnName]);
        if (!_data || _data === '') {
            if ((e.columnName === 'delAccRemark' && dataDelAccResson === 'other') || e.columnName !== 'delAccRemark') {
                formDelete.setFields([
                    {
                        name: [e.columnName],
                        errors: [e.caption],
                    },
                ]);
                return true;
            }
        }
        return false;
    };

    const ApprovesDeleteAcc = () => {
        return (
            <>
                <Form
                    className='div-title-delete'
                    autoComplete='off'
                >
                    <Row className='py-2 mb-6' style={{ justifyContent: 'center' }}>
                        <div className='delete-acc-thin'>ลบบัญชีสำเร็จ</div>
                        <div className='delete-acc-bold'>ระบบได้ลบข้อมูล และได้เพิกถอนคุณออกจากงานใด ๆ</div>
                        <div className='delete-acc-bold'>ที่ได้สมัครไว้กับทางสภากาชาดไทย</div>
                        <div className='delete-acc-bold'>ผ่านเว็บไซต์ jobs.redcross.or.th เรียบร้อยแล้ว</div>
                    </Row>
                </Form>
            </>
        );
    };

    const formApprovesDeleteAcc = () => {
        return (
            <div style={{ all: 'unset' }}>
                <Form
                    className='div-body-delete'
                    layout='vertical'
                    autoComplete='off'
                >
                    <Row className='py-2'>
                        <Col className='px-2 font-normal'>
                            <div className='text-red-500'>
                                ** เมื่อลบบัญชีแล้วจะ
                                <span style={{ fontWeight: 'bold' }}>ไม่สามารถยกเลิกในภายหลังได้</span>
                                โดยข้อมูลส่วนตัวและประวัติการสมัครงานทุกตำแหน่งของคุณ ที่ได้สมัครไว้จะถูกเพิกถอนและถูกลบออกไปอย่างถาวร **
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    };

    const warningDeleteAcc = () => {
        return (
            <>
                <Form
                    className='div-title-delete'
                    autoComplete='off'
                >
                    <Row className='py-2 mb-6' style={{ justifyContent: 'center' }}>
                        <div className='delete-acc-bold'>ระบบได้ส่งคำขอลบบัญชีให้แอดมินเรียบร้อยแล้ว
                            เนื่องจากขณะนี้ใบสมัครของคุณอยู่ในกระบวนการสรรหา
                            โดยแอดมินจะดำเนินการภายใน 14 วัน
                            หากมีข้อสงสัยติดต่อได้ที่เบอร์โทร 022564055 กด 1
                        </div>
                    </Row>
                </Form>
            </>
        );
    };

    console.log("317 userData", userData);

    return (
        <>
            <div className='div-sign-out'>
                <div className='div-user-name flex justify-center items-center relative'>
                    {userData?.isLoggedIn === true &&
                        <div className='delete-acc-box'>
                            <EllipsisOutlined
                                className='icon-footer-delete-acc cursor-pointer'
                                onClick={() => deleteAcc()} />
                            {showDelete && (
                                <div className='div-btn'>
                                    <button type='button' onClick={() => { setIsShowModalDeleteAcc(true); }} >
                                        ลบบัญชี
                                    </button>
                                </div>
                            )}
                        </div>
                    }
                    <div className='profile-image absolute flex'>
                        {userData && userData.profileImage ? (
                            <img
                                className='h-full w-full'
                                src={`${config.rcAttachFileEndPoint}${userData.profileImage}`}
                                alt='profile' />
                        ) : <ImageUserEmpty />}
                    </div>
                    <Tooltip title={userData ? userData.name : null}>
                        <Text className='user-profile-name text-center line-clamp-2' name='name_login'>
                            {userData ? userData.name : null}
                        </Text>
                    </Tooltip>
                </div>
            </div >

            {showButton && (
                <Row className='py-2 '>
                    <Col span={24} className='px-2 text-center'>
                        <ButtonUC
                            style={{ width: '170px' }}
                            className='btn-custom'
                            onClick={handleLogOut}
                        >
                            ออกจากระบบ
                        </ButtonUC>
                    </Col>
                </Row>
            )
            }


            <Modal
                className={`modal-message-delete modal-message-error ${isMobile && '!flex !justify-center !inset-x-0'}`}
                // className={`modal-message-delete modal-message-error`}
                footer={false}
                okText='ลบบัญชี'
                cancelText='ยกเลิก'
                open={isShowModalDeleteAcc}
                closable={false}
                onCancel={() => setIsShowModalDeleteAcc(false)}
                width={isMobile ? '80%' : '650px'}
                style={{
                    top: isMobile ? '50%' : '',
                    transform: isMobile ? 'translateY(-50%)' : '',
                }}
            >
                {FormReasonDeleteAcc()}
            </Modal >

        </>
    );

};

export default FormSignOut;
